module.exports = __webpack_public_path__ + "static/css-c9421be52fe48fdf04839b53f8e9f1d4.png";